export default __webpack_public_path__ + "static/media/lokomotiv.116c1fd4.jpg";